export const Catalogue="Catalogue";
export const BASE_BREADCRUMB_NODE = [
  {
    absolute_path: `${window.location.protocol}//${window.location.host}/catalogues`,
    label: "MALS Team",
  },
];

export const CATALOGUE_NODE = [{ absolute_path: "", label: `${Catalogue}`}];
export const BULK_REFRESH = [{ absolute_path: "", label: `Bulk Refresh`}];
export const SOURCE_DETAIL_NODE = [
  { absolute_path: "", label: "Source Detail" },
];

export let POINTING_DETAIL_NODE = [
  { absolute_path: "", label: "Pointing Detail" },
];

export const POINTING_NODE = [{ absolute_path: "", label: "Pointing" }];

export const ALL = "ALL";

export const PLOT_X_AXIS = {
  frequency: {
    header: "freq(Hz)",
    label: "frequency(Hz)"
  },
  velocity: {
    header: "Velocity(km/s)",
    label: "Velocity(km/s)"
  }
};
